import React from "react";
import { SelectProps as MuiSelectProps, MenuItem } from "@mui/material";
import {
  StyledSelect,
  StyledInputLabel,
  StyledFormControl,
  SelectHeight,
} from "./Select.styles";
import { themePalette } from "../../../theme";

export interface SelectOptions {
  value: string;
  label: string;
}
export interface SelectProps extends Omit<
  MuiSelectProps,
  "children" | "onChange"
> {
  label: string;
  options: SelectOptions[];
  selected: string;
  onChange: (val: string) => void;
  height?: SelectHeight;
}

export const Select = (props: SelectProps): React.ReactElement => (
  <StyledFormControl>
    <StyledInputLabel>{props.label}</StyledInputLabel>
    <StyledSelect
      variant={props.variant}
      value={props.selected}
      label={props.label}
      height={props.height}
      inputProps={props.inputProps}
      MenuProps={{
        sx: {
          "& .MuiMenuItem-root.Mui-selected": {
            backgroundColor: themePalette.blueSubtle,
          },
        },
      }}
    >
      {props.options.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
          onClick={() => props.onChange(option.value)}
        >
          {option.label}
        </MenuItem>
      ))}
    </StyledSelect>
  </StyledFormControl>
);
